<app-card [classes]="['attachment', attachmentType]" [bodyStyle]="bodyStyle[attachmentType]">
  <span class="header d-flex justify-content-between">
    <span>{{ label }}</span>
    <ng-container *ngIf="allowChanges">
      <input
        hidden
        type="file"
        multiple
        #fileInput
        [accept]="allowedFileTypes[attachmentType]"
        (change)="handleUpload($event)" />
      <button class="upload-link" (click)="fileInput.click()">Upload {{ attachmentType }}s</button>
    </ng-container>
  </span>
  <div *ngIf="!attachments?.length; else attachments_div">Add a {{ attachmentType | lowercase }} to get started.</div>
  <ng-template #attachments_div>
    <div *ngIf="attachmentType == 'image'" data-toggle="modal" #imageModal data-target="#preview-image"></div>
    <div
      [class.col-3]="attachmentType == 'image'"
      [class.mb-3]="attachmentType == 'image'"
      *ngFor="let attachment of attachments">
      <app-attachment-item
        [allowChanges]="allowChanges"
        [source]="source"
        [attachment]="attachment"
        [type]="attachmentType"
        (show)="showImage($event)"
        (delete)="handleDelete(attachment.id)">
      </app-attachment-item>
    </div>
  </ng-template>
</app-card>

<div class="modal fade" id="preview-image" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <img src="{{ imageUrl }}" />
    </div>
  </div>
</div>

<app-dialog id="delete-image">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title">{{ dialogRecord.actionName }} {{ dialogRecord?.name }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'delete'">
      Are you sure you want to {{ dialogRecord.actionName | lowercase }} this <b>{{ dialogRecord?.name }}</b
      >?
    </span>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary" id="delete-image_btn-ok">Continue</button>
  </span>
</app-dialog>

<app-dialog id="delete-document">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title">{{ dialogRecord.actionName }} {{ dialogRecord?.name }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'delete'">
      Are you sure you want to {{ dialogRecord.actionName | lowercase }} this <b>{{ dialogRecord?.name }}</b
      >?
    </span>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary" id="delete-document_btn-ok">Continue</button>
  </span>
</app-dialog>
